var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCSubtack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0215 10.2592H5.97803V13.589H31.0215V10.2592ZM5.97803 16.6054V32.087L18.4998 25.1738L31.0215 32.087V16.6054H5.97803ZM31.0215 3.91306H5.97803V7.2411H31.0215V3.91306Z",
    fill: "#4C89FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCSubtack);
export default __webpack_public_path__ + "static/media/c_subtack.1423704bb475ec8f66ad2017570bf2f2.svg";
export { ForwardRef as ReactComponent };